import { memo } from 'react';

import AnimatedText from 'shared/AnimatedText';

const BlockHeader = ({ children = null, ...props }) => (
  <AnimatedText as="h2" _after={{ content: `'.'`, color: 'bg.accent' }} {...props}>
    {children}
  </AnimatedText>
);

export default memo(BlockHeader);
